<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <!--
            <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
              <i class="pi pi-arrow-left"></i>
            </button>
          -->
          <h1 class="title-main">{{'UserPages.UserLoadMasterOrders.PageTitle' | translate}}</h1>
        </div>
        <div class="col-12 md:col-6 p-fluid flex align-items-center">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}" class="p-inputtext-sm" [(ngModel)]="searchTerm" (input)="filterLoads()" />
          </span>
        </div>
        <div></div>

      </div>
      <div class="body-card">
        <div class="subtitle-container">
          <h4 class="subtitle">
            {{'UserPages.UserLoadContainersOrders.Exporter' | translate}}
          </h4>
          <button type="button" pButton pRipple
            icon="pi pi-file-excel"
            class="p-button-success mr-2 button-success-style"
            pTooltip="XLS"
            (click)="downloadExcelMaster()"
            [loading]="loading"
            tooltipPosition="bottom"
            [style]="{'width':'fit-content', 'margin-left': '2px'}">
            {{ 'UserPages.UserLoadOrders.ExportExcel' | translate }}
          </button>
        </div>
        <div class="container-filters filters-size">
          <section class="section-info" *ngIf="profile">
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-user" style="margin-right:.5em; color:grey"></i>
                {{companyName}}
              </section>
              <section class="section-data">
                <i class="pi pi-at" style="margin-right:.5em; color:grey"></i>
                {{profile.contactEmail}}
              </section>
            </section>
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-map-marker" style="margin-right:.5em; color:grey"></i>
                {{profile.contactAddress}}
              </section>
              <section class="section-data">
                <i class="pi pi-phone" style="margin-right:.5em; color:grey"></i>
                {{profile.contactPhone}}
              </section>
            </section>
          </section>

          <div class="section-filters">
            <div class="grid justify-content-end align-items-center">
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="container-filter"
                    [options]="containerFilter"
                    (onChange)="changeFilter()"
                    [filter]="true"
                    [(ngModel)]="selectedContainers"
                    optionValue="value"
                    optionLabel="label"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="container-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.containerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="week-filter"
                    [options]="weekFilter"
                    [(ngModel)]="selectedWeeks"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="week-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.weekFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="importer-filter"
                    [options]="importerFilter"
                    [(ngModel)]="selectedCompanies"
                    [filter]="true"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="importer-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.importerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="specie-filter"
                    [options]="specieFilter"
                    [(ngModel)]="selectedSpecies"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="specie-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.specieFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="variety-filter"
                    [options]="varietyFilter"
                    [(ngModel)]="selectedVarieties"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="variety-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.varietyFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="ship-filter"
                    [options]="shipFilter"
                    [(ngModel)]="selectedShip"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="ship-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.naveFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="program-filter"
                    [options]="numberProgramsFilter"
                    [(ngModel)]="selectedPrograms"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    optionValue="value"
                    optionLabel="label"
                    class="multiselect"
                  />
                  <label for="program-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.programFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                    id="transport-filter"
                    [options]="transportSelect"
                    [optionLabel]="this.lang == 'es' ? 'nameEs' : 'nameEn'"
                    optionValue="value"
                    (onChange)="changeFilter()"
                    [showClear]="false"
                    [filter]="true"
                    [(ngModel)]="selectedTransportTypes"
                    class="multiselect"
                  />
                  <label for="transport-filter">
                    {{'UserPages.UserLoadMasterOrders.filters.transportFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="col">
                <span class="p-float-label">
                  <p-multiSelect
                  id="year-filter"
                  [options]="years"
                  [(ngModel)]="yearSelect"
                  class="multiselect"
                  [selectionLimit]="1"
                  (onChange)="changeFilter()"
                  placeholder="{{'MyLoadFilter.SelectYear' | translate}}"
                  >
                  </p-multiSelect>
                  <label for="year-filter">
                    {{'MyLoadFilter.YearLabel' | translate}}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-table">
          <div  class="section-table">
            <p-table
              #loadMasterTable
              [value]="masterLoads"
              dataKey="product.pallet.id"
              [loading]="loading"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500, 1000]"
              [scrollable]="true"
              [resizableColumns]="true"
              columnResizeMode="expand"
              [lazy]="true"
              [totalRecords]="totalCount"
              scrollHeight="800px"
              (onLazyLoad)="loadMasterPage($event)"
              [tableStyle]="{ 'min-width': '50rem' }"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
              styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ProgramOrderIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ProgramName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ImportOrderIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletIdHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TransportTypeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VesselType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.WeeksHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ShippingCompany' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DeparturePort' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginAirport' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginCity' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ETD' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationAirport' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalPort' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationCity' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ETA' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ContainerNumberHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Hatch' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ReceiverName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ConsigneeName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VesselName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalCountry' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.FolioHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletBaseName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletHeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TemptaleHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TemperaturePallet' | translate }}</th>
                  <th>CSP</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CspSiteName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledGrowerCSG' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledGrowerName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Commune' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Area' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.District' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpecieHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledVarietyName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackagingHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackingDateHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackageNetWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackageGrossWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabelHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CategoryName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpeciesSizeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledSizeName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ColorName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GradeHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TreatmentName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Cases' | translate }}</th>
                  <th>%Pallet</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackingSiteName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PluCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DispatchType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExporterInstructive' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationPlantName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalContinent' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.QualityControlDateHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BookingNoHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DUS' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Ref1' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OriginCountryHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PalletBaseCode' | translate }}</th>
                  <th>CSG</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GrowerCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GrowerHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GrowerGroup' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.QuarterCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.QuarterName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SpeciesCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VarietyCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VarietyHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledVarietyCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackageCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabelCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CategoryCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Exportable' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SizeCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ColorCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LabeledSizeCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TreatmentCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Dehydration' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.RealWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PackingSiteCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LotCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TentativeReceiverCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.TentativeReceiverName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionDate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionStatus' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionCountry' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DispatchCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DispatchDate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InspectionEntity' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DispatchInspectionType' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.InstructiveCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DriverName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VehiclePlate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.WagonPlate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CustomsCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CustomsName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CodeShippingAgency' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.NameShippingAgency' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ForwarderCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ForwarderName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ShipperCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ShipperName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExporterCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExporterName' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DestinationPlantCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ReceiverCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ConsigneeCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Voyage' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.VesselCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DepartureCountry' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DeparturePortCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.DepartureDate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalPortCode' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ArrivalDate' | translate }}</th>
                  <th>MBL</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BLNoHeader' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PlaceReceipt' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ContainerDeposit' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.StackingStart' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.StackingEnd' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.SPS' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CBM' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.OceanFreight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Inland' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.LocalCharges' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Customs' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Surcharge' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Others' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.FreightPayable' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ExcessValue' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Seal' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PricePerBox' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.PlaceDelivery' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Temperature' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CutoffDateLabel' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Ot' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Ref2' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.CTR' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.Handling' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GateOut' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.ShippedBoard' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.IssuePlace' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.IssueDate' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.GrossWeight' | translate }}</th>
                  <th>{{ 'UserPages.UserLoadMasterOrders.MainTable.BagTypeHeader' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.directSaleProgramId.toString() }}</td>
                  <td>{{ product.programName }}</td>
                  <td>{{ product.pallet.importOrderDetail.importOrder.sequence  }}</td>
                  <td>{{ product.pallet.id }}</td>
                  <td>{{ product.pallet.importOrderDetail.importOrder.transportType | transportName }}</td>
                  <td>{{ product.delivery?.vesselType }}</td>
                  <td>{{ product.delivery?.week }}</td>
                  <td>{{ product.delivery?.shippingCompanyName }}</td>
                  <td>{{ product.delivery?.departurePortName }}</td>
                  <td>{{ product.delivery?.departureAirport?.name }}</td>
                  <td>{{ product.delivery?.departureCity?.name }}</td>
                  <td>{{ product.delivery?.etd | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.arrivalPort }}</td>
                  <td>{{ product.delivery?.destinationAirport?.name }}</td>
                  <td>{{ product.delivery?.destinationCity?.name }}</td>
                  <td>{{ product.delivery?.eta | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.pallet.excelImportContainerNumber }}</td>
                  <td>{{ product.delivery?.hatch }}</td>
                  <td>{{ product.delivery?.receiverName }}</td>
                  <td>{{ product.delivery?.consigneeCompanyName }}</td>
                  <td>{{ product.delivery?.ship }}</td>
                  <td>{{ product.delivery?.arrivalCountry }}</td>
                  <td>{{ product.pallet.palletNumber }}</td>
                  <td>{{ product.pallet.palletBaseName }}</td>
                  <td>{{ product.pallet.palletHeight }}</td>
                  <td>{{ product.pallet.excelImportTemptale }}</td>
                  <td>{{ product.pallet.temperature }}</td>
                  <td>{{ product.pallet.csp }}</td>
                  <td>{{ product.pallet.siteNameCsp }}</td>
                  <td>{{ product.pallet.labeledGrowerCSG }}</td>
                  <td>{{ product.pallet.labeledGrowerName }}</td>
                  <td>{{ product.pallet.commune }}</td>
                  <td>{{ product.pallet.area }}</td>
                  <td>{{ product.pallet.district }}</td>
                  <td>{{ product.pallet.excelImportSpecies }}</td>
                  <td>{{ product.pallet.labeledVarietyName }}</td>
                  <td>{{ product.pallet.excelImportPackaging }}</td>
                  <td>{{ product.pallet.excelImportHarvestDate }}</td>
                  <td>{{ product.pallet.excelImportNetWeight }}</td>
                  <td>{{ product.pallet.packageGrossWeight }}</td>
                  <td>{{ product.pallet.excelImportTag }}</td>
                  <td>{{ product.pallet.category }}</td>
                  <td>{{ product.pallet.speciesSize }}</td>
                  <td>{{ product.pallet.labeledSizeName }}</td>
                  <td>{{ product.pallet.colorName }}</td>
                  <td>{{ product.pallet.excelImportGrade }}</td>
                  <td>{{ product.pallet.treatmentName }}</td>
                  <td>{{ product.pallet.excelImportBoxesPerPallet }}</td>
                  <td>{{ product.pallet.pallets }}</td>
                  <td>{{ product.pallet.packingSiteName }}</td>
                  <td>{{ product.pallet.pluCode }}</td>
                  <td>{{ product.pallet.inspectionType }}</td>
                  <td>{{ product.delivery?.dispatchType }}</td>
                  <td>{{ product.delivery?.exporterInstructive }}</td>
                  <td>{{ product.pallet?.excelImportFridgeStorage }}</td>
                  <td>{{ product.delivery?.arrivalContinent }}</td>
                  <td>{{ product.pallet.excelImportQualityControlDate }}</td>
                  <td>{{ product.delivery?.booking }}</td>
                  <td>{{product.delivery?.dus}}</td>
                  <td>{{ product.delivery?.ref1 }}</td>
                  <td>{{ product.pallet.importOrderDetail?.exportOffer.exporter?.contactCountry | countryDescription }}</td>
                  <td>{{ product.pallet.palletBaseCode }}</td>
                  <td>{{ product.pallet.csg }}</td>
                  <td>{{ product.pallet.growerCode }}</td>
                  <td>{{ product.pallet.producer }}</td>
                  <td>{{ product.pallet.growerGroup }}</td>
                  <td>{{ product.pallet.quarterCode }}</td>
                  <td>{{ product.pallet.quarterName }}</td>
                  <td>{{ product.pallet.speciesCode }}</td>
                  <td>{{ product.pallet.varietyCode }}</td>
                  <td>{{ product.pallet.excelImportVariety }}</td>
                  <td>{{ product.pallet.labeledVarietyCode }}</td>
                  <td>{{ product.pallet.packageCode }}</td>
                  <td>{{ product.pallet.labelCode }}</td>
                  <td>{{ product.pallet.categoryCode }}</td>
                  <td>{{ product.pallet.exportable }}</td>
                  <td>{{ product.pallet.sizeCode }}</td>
                  <td>{{ product.pallet.colorCode }}</td>
                  <td>{{ product.pallet.labeledSizeCode }}</td>
                  <td>{{ product.pallet.treatmentCode }}</td>
                  <td>{{ product.pallet.dehydration }}</td>
                  <td>{{ product.pallet.realWeight }}</td>
                  <td>{{ product.pallet.packingSiteCode }}</td>
                  <td>{{ product.pallet.lotCode }}</td>
                  <td>{{ product.pallet.tentativeReceiverCode }}</td>
                  <td>{{ product.pallet.tentativeReceiverName }}</td>
                  <td>{{ product.pallet.inspectionCode }}</td>
                  <td>{{ product.pallet.inspectionDate }}</td>
                  <td>{{ product.pallet.inspectionStatus }}</td>
                  <td>{{ product.pallet.inspectionCountry }}</td>
                  <td>{{ product.delivery?.dispatchCode }}</td>
                  <td>{{ product.delivery?.dispatchDate }}</td>
                  <td>{{ product.delivery?.inspectionEntity }}</td>
                  <td>{{ product.delivery?.dispatchInspectionType }}</td>
                  <td>{{ product.delivery?.deliveryInstructions }}</td>
                  <td>{{ product.delivery?.driverName }}</td>
                  <td>{{ product.delivery?.vehiclePlate }}</td>
                  <td>{{ product.delivery?.wagonPlate }}</td>
                  <td>{{ product.delivery?.customsCode }}</td>
                  <td>{{ product.delivery?.customsName }}</td>
                  <td>{{ product.delivery?.codeShippingAgency }}</td>
                  <td>{{ product.delivery?.nameShippingAgency }}</td>
                  <td>{{ product.delivery?.forwarderCode }}</td>
                  <td>{{ product.delivery?.forwarderName }}</td>
                  <td>{{ product.delivery?.shipperCode }}</td>
                  <td>{{ product.delivery?.shipperName }}</td>
                  <td>{{ product.delivery?.exporterCode }}</td>
                  <td>{{ product.delivery?.exporterName }}</td>
                  <td>{{ product.delivery?.destinationPlantCode }}</td>
                  <td>{{ product.delivery?.receiverCode }}</td>
                  <td>{{ product.delivery?.consigneeCode }}</td>
                  <td>{{ product.delivery?.voyageNumber }}</td>
                  <td>{{ product.delivery?.vesselCode }}</td>
                  <td>{{ product.delivery?.departureCountry }}</td>
                  <td>{{ product.delivery?.departurePortCode }}</td>
                  <td>{{ product.delivery?.departureDate | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.arrivalPortCode }}</td>
                  <td>{{ product.delivery?.arrivalDate | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.mbl }}</td>
                  <td>{{ product.delivery?.bl }}</td>
                  <td>{{ product.delivery?.placeReceipt }}</td>
                  <td>{{product.delivery?.containerDeposit}}</td>
                  <td>{{product.delivery?.stackingStart | date: 'dd-MM-yyyy'}}</td>
                  <td>{{product.delivery?.stackingEnd | date: 'dd-MM-yyyy'}}</td>
                  <td>{{product.delivery?.sps}}</td>
                  <td>{{ product.delivery?.containerCbm }}</td>
                  <td>{{ product.delivery?.oceanFreight }}</td>
                  <td>{{ product.delivery?.inland }}</td>
                  <td>{{ product.delivery?.localCharges }}</td>
                  <td>{{ product.delivery?.customs }}</td>
                  <td>{{ product.delivery?.surcharge }}</td>
                  <td>{{ product.delivery?.otherCosts }}</td>
                  <td>{{ product.delivery?.freightPayableAt }}</td>
                  <td>{{ product.delivery?.excessValueDeclaration }}</td>
                  <td>{{ product.delivery?.seal }}</td>
                  <td>{{ product.pallet.importOrderDetail?.price | currency: 'USD' }}</td>
                  <td>{{ product.delivery?.placeDelivery }}</td>
                  <td>{{ product.delivery?.containerTemperature }}</td>
                  <td>{{product.delivery?.cutoffDate | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.delivery?.ot }}</td>
                  <td>{{ product.delivery?.ref2 }}</td>
                  <td>{{ product.delivery?.ctr }}</td>
                  <td>{{ product.delivery?.handling }}</td>
                  <td>{{ product.delivery?.gateOut }}</td>
                  <td>{{ product.delivery?.shippedOnBoard  | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.delivery?.placeIssue }}</td>
                  <td>{{ product.delivery?.dateIssue | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ product.delivery?.grossWeight }}</td>
                  <td>{{ product.pallet.excelImportBagType }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-user-dashboard>
